/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTimeBlockTemplateDto } from '../models/work-create-time-block-template-dto';
import { WorkCreateTimeBlockTemplateEntryDto } from '../models/work-create-time-block-template-entry-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkTimeBlockTemplate } from '../models/work-time-block-template';
import { WorkTimeBlockTemplateEntry } from '../models/work-time-block-template-entry';
import { WorkUpdateTimeBlockTemplateDto } from '../models/work-update-time-block-template-dto';
import { WorkUpdateTimeBlockTemplateEntryDto } from '../models/work-update-time-block-template-entry-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimeBlockTemplatesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerGetAllDropdownOptions()` */
  static readonly TimeBlockTemplatesV2ControllerGetAllDropdownOptionsPath = '/v1/time-block-templates-v2/dropdown-options';

  /**
   * Get dropdown options for time block templates.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Get dropdown options for time block templates.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.timeBlockTemplatesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerFindAll()` */
  static readonly TimeBlockTemplatesV2ControllerFindAllPath = '/v1/time-block-templates-v2';

  /**
   * Get all active time block templates.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimeBlockTemplate>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimeBlockTemplate>>;
      })
    );
  }

  /**
   * Get all active time block templates.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTimeBlockTemplate>> {
    return this.timeBlockTemplatesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimeBlockTemplate>>): Array<WorkTimeBlockTemplate> => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerCreate()` */
  static readonly TimeBlockTemplatesV2ControllerCreatePath = '/v1/time-block-templates-v2';

  /**
   * Create a new time block template.
   *
   * Required permissions: time-block-templates:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerCreate$Response(
    params: {
      body: WorkCreateTimeBlockTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimeBlockTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimeBlockTemplate>;
      })
    );
  }

  /**
   * Create a new time block template.
   *
   * Required permissions: time-block-templates:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerCreate(
    params: {
      body: WorkCreateTimeBlockTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkTimeBlockTemplate> {
    return this.timeBlockTemplatesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimeBlockTemplate>): WorkTimeBlockTemplate => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerFindOne()` */
  static readonly TimeBlockTemplatesV2ControllerFindOnePath = '/v1/time-block-templates-v2/{id}';

  /**
   * Get a single time block template by id.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimeBlockTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimeBlockTemplate>;
      })
    );
  }

  /**
   * Get a single time block template by id.
   *
   * Required permissions: time-block-templates:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTimeBlockTemplate> {
    return this.timeBlockTemplatesV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimeBlockTemplate>): WorkTimeBlockTemplate => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerUpdate()` */
  static readonly TimeBlockTemplatesV2ControllerUpdatePath = '/v1/time-block-templates-v2/{id}';

  /**
   * Update a time block template.
   *
   * Required permissions: time-block-templates:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTimeBlockTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimeBlockTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimeBlockTemplate>;
      })
    );
  }

  /**
   * Update a time block template.
   *
   * Required permissions: time-block-templates:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTimeBlockTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkTimeBlockTemplate> {
    return this.timeBlockTemplatesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimeBlockTemplate>): WorkTimeBlockTemplate => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerDelete()` */
  static readonly TimeBlockTemplatesV2ControllerDeletePath = '/v1/time-block-templates-v2/{id}';

  /**
   * Delete a time block template.
   *
   * Required permissions: time-block-templates:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete a time block template.
   *
   * Required permissions: time-block-templates:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.timeBlockTemplatesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions()` */
  static readonly TimeBlockTemplatesV2ControllerGetUserTimeBlockSuggestionsPath = '/v1/time-block-templates-v2/suggestions/user/{userId}';

  /**
   * Get time block suggestions for a user based on their useremployment.
   *
   * Required permissions: time-block-template-entries:read, timerecorddetails:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions$Response(
    params: {
      userId: number;
      date: string;
      withAutoCreated: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerGetUserTimeBlockSuggestionsPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.query('date', params.date, {});
      rb.query('withAutoCreated', params.withAutoCreated, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>;
      })
    );
  }

  /**
   * Get time block suggestions for a user based on their useremployment.
   *
   * Required permissions: time-block-template-entries:read, timerecorddetails:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions(
    params: {
      userId: number;
      date: string;
      withAutoCreated: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimeBlockTemplateEntry>> {
    return this.timeBlockTemplatesV2ControllerGetUserTimeBlockSuggestions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>): Array<WorkTimeBlockTemplateEntry> => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerFindEntries()` */
  static readonly TimeBlockTemplatesV2ControllerFindEntriesPath = '/v1/time-block-templates-v2/{id}/entries';

  /**
   * Get all entries of a time block template.
   *
   * Required permissions: time-block-template-entries:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerFindEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindEntries$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerFindEntriesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>;
      })
    );
  }

  /**
   * Get all entries of a time block template.
   *
   * Required permissions: time-block-template-entries:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerFindEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerFindEntries(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimeBlockTemplateEntry>> {
    return this.timeBlockTemplatesV2ControllerFindEntries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimeBlockTemplateEntry>>): Array<WorkTimeBlockTemplateEntry> => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerCreateEntry()` */
  static readonly TimeBlockTemplatesV2ControllerCreateEntryPath = '/v1/time-block-templates-v2/entries';

  /**
   * Create a new time block template entry.
   *
   * Required permissions: time-block-template-entries:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerCreateEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerCreateEntry$Response(
    params: {
      body: WorkCreateTimeBlockTemplateEntryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimeBlockTemplateEntry>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerCreateEntryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimeBlockTemplateEntry>;
      })
    );
  }

  /**
   * Create a new time block template entry.
   *
   * Required permissions: time-block-template-entries:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerCreateEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerCreateEntry(
    params: {
      body: WorkCreateTimeBlockTemplateEntryDto
    },
    context?: HttpContext
  ): Observable<WorkTimeBlockTemplateEntry> {
    return this.timeBlockTemplatesV2ControllerCreateEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimeBlockTemplateEntry>): WorkTimeBlockTemplateEntry => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerUpdateEntry()` */
  static readonly TimeBlockTemplatesV2ControllerUpdateEntryPath = '/v1/time-block-templates-v2/entries/{id}';

  /**
   * Update a time block template entry.
   *
   * Required permissions: time-block-template-entries:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerUpdateEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerUpdateEntry$Response(
    params: {
      id: number;
      body: WorkUpdateTimeBlockTemplateEntryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimeBlockTemplateEntry>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerUpdateEntryPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimeBlockTemplateEntry>;
      })
    );
  }

  /**
   * Update a time block template entry.
   *
   * Required permissions: time-block-template-entries:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerUpdateEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timeBlockTemplatesV2ControllerUpdateEntry(
    params: {
      id: number;
      body: WorkUpdateTimeBlockTemplateEntryDto
    },
    context?: HttpContext
  ): Observable<WorkTimeBlockTemplateEntry> {
    return this.timeBlockTemplatesV2ControllerUpdateEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimeBlockTemplateEntry>): WorkTimeBlockTemplateEntry => r.body)
    );
  }

  /** Path part for operation `timeBlockTemplatesV2ControllerDeleteEntry()` */
  static readonly TimeBlockTemplatesV2ControllerDeleteEntryPath = '/v1/time-block-templates-v2/entries/{id}';

  /**
   * Delete a time block template entry.
   *
   * Required permissions: time-block-template-entries:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timeBlockTemplatesV2ControllerDeleteEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerDeleteEntry$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimeBlockTemplatesV2Service.TimeBlockTemplatesV2ControllerDeleteEntryPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete a time block template entry.
   *
   * Required permissions: time-block-template-entries:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timeBlockTemplatesV2ControllerDeleteEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timeBlockTemplatesV2ControllerDeleteEntry(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.timeBlockTemplatesV2ControllerDeleteEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
